import IcFollowUp from './IcFollowUp'
export default IcFollowUp
